import React, { useMemo, useRef, useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { requestFormPost, requestGet } from '@/common/request';

import { RightOutlined, CopyOutlined } from '@ant-design/icons';
import Copy from '@/components/copy';
import { withRouter } from 'react-router-dom';
import { getQuery } from '@/common/utils';
import goto from '@/common/goto';
import env from '@/env';
import { useSlideMenuCollapse } from '@/hooks/useSlideMenuCollapsedChange';
import DetailHeaderInfoWrapper from '@/components/detail-header-info-wrapper';

import Microapp from '@/components/micro-app';
import { useQueryHeader } from '@/apis/platform/header';
import roomApis from '@/apis/room/index';
import wareApis from '@/apis/ware/index';
import cateApi from '@/apis/cate/index';
import useHideBreadCrumbs from '@/components/bread-crumbs/use-hide-bread-crumbs';
import ContextProviderMenus from '@/components/slide-menu/provide-slide-menu';
import PoolRule from './pool-rule';
import Container from '@/components/container';
import JdImg from '@/components/jd-img';
import { formateTimeStamp } from '@/common/utils';

import './index.less';
import { Button, message, Tooltip, Alert } from 'antd';

/*****************
 * 门槛规则 - 设置 - 提报 *
 *****************/
const MaterialPoolRuleNew = withRouter((props) => {
  const history = useHistory();
  const location = useLocation();
  // 隐藏侧边栏
  useSlideMenuCollapse();
  const channelId = getQuery('planCode');
  const poolId = getQuery('poolId');
  const blockId = getQuery('blockId');
  const activityId = getQuery('activityId');

  const status = getQuery('status');
  const query = useMemo(() => ({ channelId }), [channelId]);
  const [ruleId, setRuleId] = useState(null);

  const [poolData, setPoolData] = useState({});
  const [showHeader, setShowHeader] = useState(true);
  const [permission, setPermission] = useState({});
  const [dailyData, setDailyData] = useState({});
  const [showNav, setShowNav] = useState(true);
  const [batchList, setBatchList] = useState([]);
  const [erps, setErps] = useState([]);
  const [chosenBatchIndex, setChosenBatchIndex] = useState(0);
  const [chosenErpIndex, setChosenErpIndex] = useState(-1);
  const [isInvitedList, setIsInvitedList] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [isDaily, setIsDaily] = useState(location.pathname.startsWith('/activity-manage'));
  const [headerExtraProps, setHeaderExtraProps] = useState({});
  useHideBreadCrumbs();
  const pandoraRef = useRef();

  function changeBatchItem(batchItem, batchIndex) {
    setChosenBatchIndex(batchIndex);
    setSelectedBatch(batchItem);
  }
  function changeErpItem(erp, chosenErpIndex) {
    setChosenErpIndex(chosenErpIndex);
  }

  const batchParams = {
    status: 'disabled',
    poolType: 19,
    planCode: channelId, // 阵地id
    ref: pandoraRef,
    ruleId: ruleId || '',
    disable: 'true',
    activityId: getQuery('activityId'), //
    blockId: getQuery('blockId'),
  };
  useEffect(() => {
    async function fetchErps() {
      if (!selectedBatch || !selectedBatch.id) return;
      const res = await requestGet(`/generic/mac/batch/selectionInvitedErps?batchId=${selectedBatch.id}`);
      if (res.ret === '0' && res.data) {
        setErps(res.data.data);
        res.data.data.length && setChosenErpIndex(0);
      }
    }
    fetchErps();
  }, [selectedBatch]);
  useEffect(() => {
    function queryRuleId() {
      if (selectedBatch && selectedBatch.id && erps.length && chosenErpIndex > -1) {
        setRuleId('');
        requestGet(
          `/generic/mac/common/query/ruleset?resourceId=${selectedBatch.id}&resourceType=3&erpNo=${erps[chosenErpIndex].userName}`
        ).then((res) => {
          if (res.ret === '0' && res.data && res.data.ruleId) {
            setRuleId(res.data.ruleId);
          }
        });
      }
    }
    queryRuleId();
  }, [selectedBatch, chosenErpIndex, erps]);
  useEffect(() => {
    setTimeout(() => {
      window.dispatchEvent(new PopStateEvent('popstate', { state: window.history.state }));
    });
  }, [ruleId]);
  // useEffect(() => {
  //   if (!activityId || !blockId) {
  //     setPoolData({});
  //     return;
  //   }
  //   roomApis
  //     .poolHeader({
  //       tibaoId: activityId,
  //       poolId: blockId,
  //     })
  //     .then(({ ret, msg, data }) => {
  //       if (ret === '0') {
  //         setPoolData(data);
  //       } else {
  //         message.error(msg);
  //       }
  //     });
  // }, [activityId, blockId]);
  useEffect(() => {
    async function fetchBatch(params) {
      const batchRes = await requestFormPost(
        `/generic/mac/batch/manage/page?areaId=${blockId}&orderBy=beginTime ASC&pageSize=1000`
      );
      if (batchRes.ret === '0' && batchRes.data) {
        setBatchList(batchRes.data.items);
        setSelectedBatch(batchRes.data.items[0]);
      }
    }
    fetchBatch();
  }, [blockId]);
  const headerPermission = permission?.modules?.functions?.room_header;
  return (
    <ContextProviderMenus.Provider
      value={{
        children: props.children,
        setShowHeader,
        setShowNav,
        setHeaderExtraProps,
        // roomId: dailyData.roomId,
        activityId: activityId,
        // dailyData,
        permission,
      }}
    >
      <Container bg={false} padding={false} margin={false}>
        <div className="alert-wrapper">
          <PoolRule />
          <Alert
            className="rule-alert"
            message="已分配人ERP仅展示在该场次下设置了选品规则的用户"
            type="warning"
            showIcon
          />
        </div>
        <div className="material-pool-rule-new-wrapper" ref={pandoraRef}>
          <div className="rule-new-header-fa"></div>
          <div className="ruleSetAndInvite_mainContent">
            <div className="ruleSetAndInvite_batchArea">
              <div className="ruleSetAndInvite_batchList">
                <span className="title">场次选择：</span>
                {batchList.length !== 0 ? (
                  <div className="batchList_area">
                    <div className="batch_list">
                      {batchList.map((item, index) => {
                        return (
                          <div
                            className={`ruleSetAndInvite_batchTag ${!!item.isHistory && 'tag_history'} ${
                              chosenBatchIndex === index && 'tag_chosen'
                            }`}
                            key={`batch_${index}`}
                            onClick={() => changeBatchItem(item, index)}
                          >
                            <span>{item.beginTime}</span>
                            <span>{item.endTime}</span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ) : (
                  <div className="title">无可用场次</div>
                )}
              </div>
            </div>
            <div className="ruleSetAndInvite_batchArea">
              <div className="ruleSetAndInvite_batchList">
                <span className="title">已分配人ERP：</span>
                {erps.length !== 0 ? (
                  <div className="batchList_area">
                    <div className="batch_list">
                      {erps.map((item, index) => {
                        return (
                          <div
                            className={`ruleSetAndInvite_batchTag ${chosenErpIndex === index && 'tag_chosen'}`}
                            key={`erp_${index}`}
                            onClick={() => changeErpItem(item, index)}
                          >
                            {item.realName}&emsp;{item.userName}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ) : (
                  <div className="title">该场次无分配或已分配对象未设置选品规则</div>
                )}
              </div>
            </div>
            <div className="ruleSetAndInvite_pandora_wrapper"></div>
          </div>
          <div className="rule-new-body-fa">
            <Microapp
              // inhash="/integration/yx-promotion"
              inhash={`/integration/yx-promotion?ruleId=${ruleId || ''}&disable=true`}
              destory={true}
              data={batchParams}
              name="materialpoolrulesetting"
              url={env.ACE_DOMAIN + '/pandora/'}
            />
          </div>
        </div>
      </Container>
    </ContextProviderMenus.Provider>
  );
});

export default MaterialPoolRuleNew;
